import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAfterpay = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 48,
	height: 24,
	viewBox: "0 0 48 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", {
		id: "Type=Afterpay / Clearpay",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Vector",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_2",
					d: "M32.249 11.5005C32.249 16.3322 28.3308 20.2505 23.499 20.2505C18.6673 20.2505 14.749 16.3322 14.749 11.5005C14.749 6.66874 18.6673 2.75049 23.499 2.75049C28.3308 2.75049 32.249 6.66874 32.249 11.5005Z",
					fill: "#B2FCE3"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_3",
					d: "M23.4613 16.7998C23.1489 16.9866 22.8024 17.0785 22.4589 17.0785C22.1216 17.0785 21.7878 16.9928 21.4811 16.8151L18.3491 15.0069C17.7269 14.6482 17.3621 14.0046 17.3743 13.2845C17.3866 12.5674 17.7698 11.9331 18.4042 11.5958L21.426 9.97439C22.0451 9.6432 22.7652 9.64626 23.3506 9.98357C23.9053 10.3056 24.2514 10.8905 24.2733 11.5498C24.2855 11.9729 23.9543 12.3281 23.5317 12.3404C23.0964 12.3526 22.7534 12.0214 22.7411 11.5988C22.7381 11.4671 22.6829 11.3691 22.5849 11.3109C22.4624 11.2405 22.3001 11.2466 22.1496 11.3263L19.1278 12.9441C18.9318 13.0513 18.9073 13.2351 18.9073 13.309C18.9043 13.3825 18.9226 13.5693 19.1156 13.68L22.2476 15.4882C22.4406 15.5984 22.6094 15.5219 22.6738 15.4851C22.7381 15.4453 22.8851 15.332 22.8789 15.1111L22.8553 14.5738C22.8444 14.3297 23.1095 14.1718 23.3191 14.2973L24.128 14.7816C24.2186 14.8359 24.2776 14.9339 24.2781 15.0398C24.2807 15.8513 24.0401 16.4511 23.4613 16.7998Z",
					fill: "#000100"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_4",
					d: "M29.6252 9.85169C29.6129 10.5688 29.2266 11.2001 28.5922 11.5404L25.5704 13.1618C25.2607 13.3272 24.9299 13.4099 24.6018 13.4099C24.2706 13.4099 23.946 13.3241 23.6546 13.1588C23.1029 12.8398 22.763 12.2579 22.7415 11.5986C22.7293 11.1756 23.0605 10.8203 23.4831 10.8081H23.5299C23.9477 10.8081 24.2492 11.1524 24.2745 11.5698C24.282 11.6909 24.3305 11.7793 24.4207 11.8318C24.537 11.8992 24.6963 11.89 24.8468 11.8104L27.8686 10.1921C28.0677 10.0849 28.0891 9.90113 28.0922 9.82719C28.0922 9.75063 28.0738 9.56688 27.8808 9.45619L24.7518 7.648C24.5589 7.53775 24.387 7.61431 24.3257 7.65106C24.2614 7.69088 24.1144 7.80113 24.1205 8.02513C24.1341 8.21806 24.1455 8.37644 24.1547 8.50638C24.1722 8.75575 23.9 8.91981 23.6878 8.78856L22.8793 8.28806C22.7932 8.23469 22.7358 8.14238 22.7328 8.04131C22.7127 7.36275 22.9178 6.70825 23.5387 6.33638C24.1547 5.96844 24.8932 5.96231 25.5183 6.32106L28.6473 8.12925C29.2695 8.488 29.6343 9.13156 29.6252 9.85169Z",
					fill: "#000100"
				})
			]
		})
	}) })
});
export default SvgAfterpay;
